export const LABELS = {
  numberOfFinancialDependents17Under:
    "How many financial dependents do the applicants have aged 17 or under?",
  numberOfFinancialDependentsOver17:
    "How many financial dependents do the applicants have aged over 17?",
};
